import React, { useState, useEffect } from "react"
import { Box, Text, Flex, Inline } from '@sqymagma/elements'
import { formatNumberDot } from '../../../utils/formatNumber'
import { theme } from '../../../utils/themeGet'
import DataEsLoader from "../Loaders/DataEsLoader"

export default ( { date } ) => {

    // Client-side Runtime Data Fetching
    // https://www.gatsbyjs.org/docs/data-fetching/
    const [confirmados, setConfirmados] = useState(null)
    const [fallecidos, setFallecidos] = useState(null)
    const [recuperados, setRecuperados] = useState(null)
    
    useEffect(() => {
    fetch(`https://covid19.secuoyas.io/api/v1/mod/dataes?fecha=${date}`)
        .then(response => response.json()) // parse JSON from request
        .then(resultData => {
            setConfirmados(resultData && {...resultData.confirmados, color: "support02"})
            setFallecidos(resultData && {...resultData.fallecidos, color: "support01"})
            setRecuperados(resultData && {...resultData.recuperados, color: "support03"})
    
        }) 
        .catch(err => console.log("Error getting data from API: "+err))
    }, [date])


return (
    <Box width={1} >
        <Flex width={1} p="xs" bg="white" css={`{ border: 1px solid ${theme("color.ui02")} }`} borderRadius="3px">
            <SubModDataEs item={confirmados} title="Casos confirmados"/> 
            <Box css={`{ border-right: 1px solid ${theme("color.ui02")} }`}></Box> 
            <SubModDataEs item={fallecidos} title="Fallecidos"/>  
            <Box css={`{ border-right: 1px solid ${theme("color.ui02")} }`}></Box> 
            <SubModDataEs item={recuperados} title="Recuperados"/>  
        </Flex>
    </Box>
)}


 export const SubModDataEs = ( { item, title } ) => (
    item ? (
        <Box width={1/3} px="xs">
            <Text as="h4" textStyle="xs" caps>{ title }</Text>
            <Text as="p" textStyle="xl" color="text05">{formatNumberDot(item.acumulado)}</Text>
            <Inline alignItems="center" mb="xs">
                <Text as="h4" textStyle="l" color={item.color}>{item.variacion}%</Text>
                <Box height="22px" width="22px">
                    <img src={item.tendencia !== 0 ? (item.tendencia >= 1  ? "/../svg/trend-positive.svg" : "/../svg/trend-negative.svg" ) : "/../svg/trend-neutral.svg"} alt="Tendencia"/>
                </Box>
            </Inline>
            <Box 
                bg="ui02" height="10px" borderRadius="10px"
                position="relative" overflow="hidden"
            >
                <Box 
                    width={`${item.progreso}%`} 
                    bg={item.color}
                    position="absolute" top="0" bottom="0"
                />
            </Box>
        </Box>
    ) : <Box px="xs" pt="4px">
        <DataEsLoader/>
        </Box>
 )